import { Box } from '@chakra-ui/react'
import CarouselTable from './components/CarouselTable'
import CarouselHeadlineManager from './components/CarouselHeadlineManager'

export default function CarouselSlides () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <CarouselHeadlineManager />
      <CarouselTable />
    </Box>
  )
}
